module.exports = __webpack_public_path__ + "1b8f85d7a92c876aab81edb95703693d.svg";